// Sprint 41.2 — Modelo ÚNICO del Corte de Caja (fuente de verdad del FORMATO para Web).
// Lo consumen el builder ESC/POS (escposHelper.buildCorteTicket) y los renderizadores DOM
// (CorteThermalReceipt, CajaTurnoBar), para que Terminal y Valet impriman idéntico en 58/80mm.
// NO calcula lógica de negocio: solo ordena/deriva datos que ya vienen del backend (turno-resumen
// y ultimo-corte). Regla crítica: FECHA DE OPERACIÓN = fecha de APERTURA del turno (no el cierre).
import { fmtDate, fmtTime } from "./datetime";

export const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export function buildCorteModel(r = {}, { efectivoContado, reimpresion = false } = {}) {
  const tz = r.zona_horaria || undefined;
  const fAp = r.fecha_apertura || null;
  const fCi = r.fecha_cierre || null;

  const efvo = Number(r.ingresos_efectivo || 0);
  const fondo = Number(r.fondo_inicial || 0);
  const fr = Number(r.monto_factor_riesgo_aplicado || 0);
  const frN = Number(r.folios_factor_riesgo || 0);
  const frCuota = frN > 0 ? fr / frN : 0;
  const gastos = Number(r.total_gastos || 0);
  const propinas = Number(r.retiro_propinas || 0);
  const subtotal = Math.round((efvo + fondo + fr) * 100) / 100; // = efectivo esperado + FR (una vez)
  const totalEntregar = Number(r.efectivo_neto_entregar || 0);   // = subtotal - gastos - propinas

  const contado = (efectivoContado === "" || efectivoContado == null) ? null : Number(efectivoContado);
  const diferencia = contado == null ? null : Math.round((contado - totalEntregar) * 100) / 100;
  const estadoCaja = diferencia == null ? null
    : (Math.abs(diferencia) < 0.005 ? "Caja cuadrada" : (diferencia > 0 ? "Sobrante" : "Faltante"));

  // Desglose por concepto: solo conceptos habilitados en la sucursal (aunque sea $0.00).
  // Productos NO tiene bandera propia → se muestra únicamente si tuvo ventas (> 0).
  const conceptos = [];
  if (r.cfg_tarjeta) conceptos.push({ label: "Tarjeta Point", monto: Number(r.ingresos_tarjeta || 0) });
  if (r.cfg_estacionamiento) conceptos.push({ label: "Estacionamiento", monto: Number(r.ventas_estacionamiento || 0) });
  if (r.cfg_valet) conceptos.push({ label: "Valet", monto: Number(r.ventas_valet || 0) });
  if (Number(r.ventas_productos || 0) > 0) conceptos.push({ label: "Productos", monto: Number(r.ventas_productos || 0) });
  if (r.cfg_servicios) conceptos.push({ label: "Servicios adicionales", monto: Number(r.ventas_servicios || 0) });

  return {
    tz,
    operacionFecha: fAp ? fmtDate(fAp, {}, tz) : "—",
    inicioTxt: fAp ? `${fmtDate(fAp, {}, tz)} ${fmtTime(fAp, {}, tz)}` : "—",
    cierreTxt: fCi ? `${fmtDate(fCi, {}, tz)} ${fmtTime(fCi, {}, tz)}` : "En curso",
    reimpresion,
    liquidacion: {
      generados: Number(r.folios_totales_turno || 0),
      cancelados: Number(r.conteo_cancelados || 0),
      cortesias: Number(r.conteo_cortesias || 0),
      cobrados: Number(r.tickets_pagados || 0),
    },
    importes: { efvo, fondo, fr, frN, frCuota, subtotal, gastos, propinas },
    totalEntregar,
    conciliacion: { totalEntregar, contado, diferencia, estadoCaja },
    conceptos,
    patio: {
      n: Number(r.vehiculos_en_patio ?? r.vehiculos_quedados_patio ?? 0),
      folios: r.folios_patio || r.folios_quedados || [],
    },
    pernoctas: { n: Number(r.conteo_pernoctas_cobradas || 0), monto: Number(r.monto_total_pernoctas_cobradas || 0) },
    gastosList: r.gastos || [],
    cancelaciones: {
      rows: r.cancelaciones_cortesias || [],
      totalCanc: Number(r.conteo_cancelados || 0),
      totalCort: Number(r.conteo_cortesias || 0),
    },
  };
}
